export default "__VITE_ASSET__6de01cb2__"